import script from "./PeggyUsdcDetected.vue?vue&type=script&lang=ts&setup=true"
export * from "./PeggyUsdcDetected.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__